/**
 * Optimiciti API Specification
 * Welcome to the Beta release of the Optimiciti API. This API allows registered users to make direct calls to our optimization solvers via a web request.  Use of the API requires acceptance of our terms of service.  Some useful links: - [Optimiciti Homepage](https://optimiciti.com) - [Optimiciti API Access Plans](https://optimiciti.com/pricing)
 *
 * The version of the OpenAPI document: 0.0.2
 * Contact: api@optimiciti.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The VehicleType model module.
 * @module model/VehicleType
 * @version 0.0.2
 */
class VehicleType {
    /**
     * Constructs a new <code>VehicleType</code>.
     * @alias module:model/VehicleType
     * @param vehicleTypeId {String} A unique identifier for this vehicle type.
     */
    constructor(vehicleTypeId) { 
        
        VehicleType.initialize(this, vehicleTypeId);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, vehicleTypeId) { 
        obj['vehicleTypeId'] = vehicleTypeId;
        obj['allowResupply'] = false;
    }

    /**
     * Constructs a <code>VehicleType</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/VehicleType} obj Optional instance to populate.
     * @return {module:model/VehicleType} The populated <code>VehicleType</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new VehicleType();

            if (data.hasOwnProperty('vehicleTypeId')) {
                obj['vehicleTypeId'] = ApiClient.convertToType(data['vehicleTypeId'], 'String');
            }
            if (data.hasOwnProperty('vehicleType')) {
                obj['vehicleType'] = ApiClient.convertToType(data['vehicleType'], 'String');
            }
            if (data.hasOwnProperty('capacity')) {
                obj['capacity'] = ApiClient.convertToType(data['capacity'], 'Number');
            }
            if (data.hasOwnProperty('allowResupply')) {
                obj['allowResupply'] = ApiClient.convertToType(data['allowResupply'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>VehicleType</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>VehicleType</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of VehicleType.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['vehicleTypeId'] && !(typeof data['vehicleTypeId'] === 'string' || data['vehicleTypeId'] instanceof String)) {
            throw new Error("Expected the field `vehicleTypeId` to be a primitive type in the JSON string but got " + data['vehicleTypeId']);
        }
        // ensure the json data is a string
        if (data['vehicleType'] && !(typeof data['vehicleType'] === 'string' || data['vehicleType'] instanceof String)) {
            throw new Error("Expected the field `vehicleType` to be a primitive type in the JSON string but got " + data['vehicleType']);
        }

        return true;
    }


}

VehicleType.RequiredProperties = ["vehicleTypeId"];

/**
 * A unique identifier for this vehicle type.
 * @member {String} vehicleTypeId
 */
VehicleType.prototype['vehicleTypeId'] = undefined;

/**
 * A name for this vehicle type.
 * @member {String} vehicleType
 */
VehicleType.prototype['vehicleType'] = undefined;

/**
 * The maximum capacity of this vehicle type, in units of demand. Leave null if this vehicle type has no capacity limit.
 * @member {Number} capacity
 */
VehicleType.prototype['capacity'] = undefined;

/**
 * Whether this vehicle type can be resupplied during an optimization run.
 * @member {Boolean} allowResupply
 * @default false
 */
VehicleType.prototype['allowResupply'] = false;






export default VehicleType;

